const CircularInitialsAvatar = ({ initials, size = "medium" }) => {
  const sizeClasses = {
    small: "size-6 text-xs",
    medium: "size-8 text-sm",
    large: "size-10 text-base",
    xlarge: "size-12 text-lg",
    xxlarge: "size-14 text-xl",
  };

  const { sizeClass, textClass } = sizeClasses[size]
    ? {
        sizeClass: sizeClasses[size].split(" ")[0],
        textClass: sizeClasses[size].split(" ")[1],
      }
    : { sizeClass: "size-8", textClass: "text-sm" };

  return (
    <span
      className={`inline-flex ${sizeClass} items-center justify-center rounded-full bg-ink-800`}
    >
      <span className={`${textClass} font-medium text-white`}>{initials}</span>
    </span>
  );
};

export default CircularInitialsAvatar;
